angular
	.module 'App.Filter'
	.filter 'wmCurrency',
		[
			'$filter'
			($filter) ->
				return (amount, currency = null, thousandsSeparator = ' ', decimalSeparator = ',', fractionSize = 2) ->
					prefix = ''
					suffix = ''

					currency ?= 'DKK'

					switch currency.toLowerCase()
						when 'eur'
							suffix = ' €'
						when 'usd'
							prefix = '$'
						when 'hkd'
							prefix = 'HK$'
						else prefix = currency.toUpperCase() + ' '

					return prefix + $filter('wmNumber')(amount || 0, thousandsSeparator, decimalSeparator, fractionSize) + suffix
		]
